import { useRef, useState, type FormEvent } from "react";
import { api } from "../api/client";

interface Props {
  /** Вызывается после успешного входа: приложению пора загружать данные. */
  onSuccess: () => void;
}

/**
 * Экран входа.
 *
 * Дашборд смотрит наружу, поэтому показания закрыты общим паролем — учётных
 * записей у сервиса нет. Форма нарочно минимальна: одно поле и кнопка.
 */
export function LoginScreen({ onSuccess }: Props) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const field = useRef<HTMLInputElement>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await api.login(password);
      onSuccess();
    } catch {
      // Причину не уточняем: единственная ожидаемая ошибка — неверный пароль,
      // а подробности о сервере тут никому не помогут.
      setError("Неверный пароль");
      setPassword("");
      field.current?.focus();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-screen">
      <form className="panel login-card" onSubmit={submit}>
        <h1>Учёт электроэнергии</h1>
        <p className="muted">Дашборд закрыт паролем.</p>

        <label className="login-field">
          <span>Пароль</span>
          <input
            ref={field}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            autoComplete="current-password"
            // Подсказка браузеру на телефоне: поле пароля, а не поиск.
            enterKeyHint="go"
          />
        </label>

        {error && (
          <div className="error-banner" role="alert">
            {error}
          </div>
        )}

        <button type="submit" className="login-submit" disabled={busy || !password}>
          {busy ? "Проверяем…" : "Войти"}
        </button>
      </form>
    </div>
  );
}
